// Pure helpers for the Google Calendar 1-click connect flow. No axios import
// so Jest can load this module (axios v1 ESM breaks CRA5's transform).

export const GCAL_OAUTH_MESSAGE_TYPE = "zoey-google-oauth";

// Mock authorize page served from public/ while USE_GCAL_MOCKS is on.
export const MOCK_GCAL_AUTHORIZE_URL = "/google-oauth-mock.html";
